import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

@inject('packageStore')
@observer
export default class BenefitModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ticketInfo: null,
      count: 1,
    }
  }

  render() {
    const {
      packageStore: {
        isOpenModal,
        closeModal,
        useCouponModal,
      },
    } = this.props;

    const cancelCoupon = () => {
      document.getElementById('count').value = '1';
      closeModal();
    }

    const useCoupon = () => {
      const count = document.getElementById('count').value;
      useCouponModal(count);
      cancelCoupon();
    }

    return (
      <div className={`App-modal ${isOpenModal ? 'modal-open' : null}`}>
        <div className="box-modal">
          <p className="txt-modal">
            사용하실 혜택 이용권의 개수를<br />입력해주세요
          </p>
          <input 
            type="number" 
            id="count" 
            defaultValue={this.state.count} 
            className="input-modal"
          />
          <div className="group-button">
            <button type="cancel" className="btn-modal" onClick={cancelCoupon}>취소</button>
            <button type="submit" className="btn-modal" onClick={useCoupon}>사용</button>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/BenefitModal.jsx